import { createFileRoute } from "@tanstack/react-router";
import { Route as HomeV4Route } from "./home-v4";

/**
 * Landing page. v4 ("Library/Journal") is the sole landing variant.
 * v5 ("Quiet Dawn") has been retired — its palette lives on as the `theme-dawn`
 * option in Settings → Appearance, and its copy is archived at
 * `.lovable/archive/home-v5-copy.md` for future marketing use.
 */
export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Tiger's Eye — Honest essay feedback before you submit" },
      {
        name: "description",
        content:
          "Honest, impartial feedback on the essay you've already written. Critique only — never ghostwriting.",
      },
      { property: "og:title", content: "Tiger's Eye — Honest essay feedback before you submit" },
      {
        property: "og:description",
        content:
          "Honest, impartial feedback on the essay you've already written. Critique only — never ghostwriting.",
      },
      { property: "og:url", content: "https://tigerseye.app/" },
    ],
    links: [{ rel: "canonical", href: "https://tigerseye.app/" }],
  }),
  component: function HomeIndex() {
    const Component = HomeV4Route.options.component as React.ComponentType;
    return <Component />;
  },
});
